<template>
  <base-modal
    :show="opened"
    :title="title"
    @on-confirm="saveItem"
    @on-cancel="hide()"
    :okText="$t('Save')"
    :closeText="$t('Close')"
    max-width="30%"
  >
    <v-row
      justify="center"
      align="center"
      v-for="(column, index) in columns"
      :key="index"
    >
      <v-col cols="11">
        <div class="text-center">
            <v-autocomplete
              v-if="column.isRelatedTable"
              :label="column.name"
              :items="column.relatedTableData"
              v-model="column.value"
              clearable
            ></v-autocomplete>
          <v-text-field v-else
            :label="column.name"
            v-model="column.value"
            clearable
          ></v-text-field>
        </div>
      </v-col>
    </v-row>
  </base-modal>
</template>

<script>
import Utils from '@/ecm/common/Utils';
export default {
    data() {
        return {
            title: '',
            opened: false,
            id: 0,
            columns: [],
        };
    },
    methods: {
        open(id, columns) {
            this.id = id;
            if (this.id > 0) {
                this.title = this.$t('Edit');
            } else {
                this.title = this.$t('Add');
            }
            this.columns = columns;
            this.opened = true;
        },
        hide() {
            this.opened = false;
        },
        saveItem() {
            const emptyRequiredFields = this.getRequiredFieldsWithoutValue();
            if (emptyRequiredFields.length > 0) {
                const message =
                    this.$t('RequiredColumnEmpty') + ' ' + emptyRequiredFields.join();
                Utils.toast.error(message);
            } else {

                if (this.id > 0) {
                    this.$emit('item-update', this.id, this.columns);
                } else {
                    this.$emit('item-add', this.columns);
                }
            }
        },
        getRequiredFieldsWithoutValue() {
            const emptyRequiredFields = [];
            this.columns.forEach((column) => {
                if (column.isRequired && (!column.value || !column.value.trim())) {
                    emptyRequiredFields.push(column.name);
                }
            });
            return emptyRequiredFields;
        }
    },
};
</script>

<style>
</style>